"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _defineProperty2 = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _styles = require("@material-ui/core/styles");
var _lodash = _interopRequireDefault(require("lodash.clonedeep"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TableBodyCell = _interopRequireDefault(require("./TableBodyCell"));
var _TableBodyRow = _interopRequireDefault(require("./TableBodyRow"));
var _TableSelectCell = _interopRequireDefault(require("./TableSelectCell"));
var _utils = require("../utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultBodyStyles = function defaultBodyStyles(theme) {
  return {
    root: {
      width: '65em'
    },
    emptyTitle: {
      textAlign: 'center'
    },
    lastStackedCell: _defineProperty2({}, theme.breakpoints.down('sm'), {
      '& td:last-child': {
        borderBottom: 'none'
      }
    }),
    bodyCell: {
      backgroundColor: 'red'
    },
    lastSimpleCell: _defineProperty2({}, theme.breakpoints.down('xs'), {
      '& td:last-child': {
        borderBottom: 'none'
      }
    })
  };
};
var TableBody = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TableBody, _react$default$Compon);
  function TableBody() {
    var _this;
    _classCallCheck(this, TableBody);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableBody).apply(this, arguments));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRowSelect", function (data, event) {
      var shiftKey = event && event.nativeEvent ? event.nativeEvent.shiftKey : false;
      var shiftAdjacentRows = [];
      var previousSelectedRow = _this.props.previousSelectedRow; // If the user is pressing shift and has previously clicked another row.
      if (shiftKey && previousSelectedRow && previousSelectedRow.index < _this.props.data.length) {
        var curIndex = previousSelectedRow.index;

        // Create a copy of the selectedRows object. This will be used and modified
        // below when we see if we can add adjacent rows.
        var selectedRows = (0, _lodash.default)(_this.props.selectedRows);

        // Add the clicked on row to our copy of selectedRows (if it isn't already present).
        var clickedDataIndex = _this.props.data[data.index].dataIndex;
        if (selectedRows.data.filter(function (d) {
          return d.dataIndex === clickedDataIndex;
        }).length === 0) {
          selectedRows.data.push({
            index: data.index,
            dataIndex: clickedDataIndex
          });
          selectedRows.lookup[clickedDataIndex] = true;
        }
        var _loop = function _loop() {
          var dataIndex = _this.props.data[curIndex].dataIndex;
          if (_this.isRowSelectable(dataIndex, selectedRows)) {
            var lookup = {
              index: curIndex,
              dataIndex: dataIndex
            };

            // Add adjacent row to temp selectedRow object if it isn't present.
            if (selectedRows.data.filter(function (d) {
              return d.dataIndex === dataIndex;
            }).length === 0) {
              selectedRows.data.push(lookup);
              selectedRows.lookup[dataIndex] = true;
            }
            shiftAdjacentRows.push(lookup);
          }
          curIndex = data.index > curIndex ? curIndex + 1 : curIndex - 1;
        };
        while (curIndex !== data.index) {
          _loop();
        }
      }
      _this.props.selectRowUpdate('cell', data, shiftAdjacentRows);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRowClick", function (row, data, event) {
      // Don't trigger onRowClick if the event was actually the expandable icon.
      if (event.target.id === 'expandable-button' || event.target.nodeName === 'path' && event.target.parentNode.id === 'expandable-button') {
        return;
      }

      // Don't trigger onRowClick if the event was actually a row selection via checkbox
      if (event.target.id && event.target.id.startsWith('MUIDataTableSelectCell')) return;

      // Check if we should toggle row select when row is clicked anywhere
      if (_this.props.options.selectableRowsOnClick && _this.props.options.selectableRows !== 'none' && _this.isRowSelectable(data.dataIndex, _this.props.selectedRows)) {
        var selectRow = {
          index: data.rowIndex,
          dataIndex: data.dataIndex
        };
        _this.handleRowSelect(selectRow, event);
      }
      // Check if we should trigger row expand when row is clicked anywhere
      if (_this.props.options.expandableRowsOnClick && _this.props.options.expandableRows && _this.isRowExpandable(data.dataIndex, _this.props.expandedRows)) {
        var expandRow = {
          index: data.rowIndex,
          dataIndex: data.dataIndex
        };
        _this.props.toggleExpandRow(expandRow);
      }

      // Don't trigger onRowClick if the event was actually a row selection via click
      if (_this.props.options.selectableRowsOnClick) return;
      _this.props.options.onRowClick && _this.props.options.onRowClick(row, data, event);
    });
    return _this;
  }
  _createClass(TableBody, [{
    key: "buildRows",
    value: function buildRows() {
      var _this$props = this.props,
        data = _this$props.data,
        page = _this$props.page,
        rowsPerPage = _this$props.rowsPerPage,
        count = _this$props.count;
      if (this.props.options.serverSide) return data.length ? data : null;
      var rows = [];
      var highestPageInRange = (0, _utils.getPageValue)(count, rowsPerPage, page);
      var fromIndex = highestPageInRange === 0 ? 0 : highestPageInRange * rowsPerPage;
      var toIndex = Math.min(count, (highestPageInRange + 1) * rowsPerPage);
      if (page > highestPageInRange) {
        console.warn('Current page is out of range, using the highest page that is in range instead.');
      }
      for (var rowIndex = fromIndex; rowIndex < count && rowIndex < toIndex; rowIndex++) {
        if (data[rowIndex] !== undefined) rows.push(data[rowIndex]);
      }
      return rows.length ? rows : null;
    }
  }, {
    key: "getRowIndex",
    value: function getRowIndex(index) {
      var _this$props2 = this.props,
        page = _this$props2.page,
        rowsPerPage = _this$props2.rowsPerPage,
        options = _this$props2.options;
      if (options.serverSide) {
        return index;
      }
      var startIndex = page === 0 ? 0 : page * rowsPerPage;
      return startIndex + index;
    }
  }, {
    key: "isRowSelected",
    value: function isRowSelected(dataIndex) {
      var selectedRows = this.props.selectedRows;
      return !!(selectedRows.lookup && selectedRows.lookup[dataIndex]);
    }
  }, {
    key: "isRowExpanded",
    value: function isRowExpanded(dataIndex) {
      var expandedRows = this.props.expandedRows;
      return !!(expandedRows.lookup && expandedRows.lookup[dataIndex]);
    }
  }, {
    key: "isRowSelectable",
    value: function isRowSelectable(dataIndex, selectedRows) {
      var options = this.props.options;
      selectedRows = selectedRows || this.props.selectedRows;
      if (options.isRowSelectable) {
        return options.isRowSelectable(dataIndex, selectedRows);
      }
      return true;
    }
  }, {
    key: "isRowExpandable",
    value: function isRowExpandable(dataIndex) {
      var _this$props3 = this.props,
        options = _this$props3.options,
        expandedRows = _this$props3.expandedRows;
      if (options.isRowExpandable) {
        return options.isRowExpandable(dataIndex, expandedRows);
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        columns = _this$props4.columns,
        toggleExpandRow = _this$props4.toggleExpandRow,
        options = _this$props4.options,
        selectCellPostion = _this$props4.selectCellPostion;
      var tableRows = this.buildRows();
      var visibleColCnt = columns.filter(function (c) {
        return c.display === 'true';
      }).length;
      return /*#__PURE__*/_react.default.createElement(_TableBody.default, null, tableRows && tableRows.length > 0 ? tableRows.map(function (data, rowIndex) {
        var _ref;
        var row = data.data,
          dataIndex = data.dataIndex;
        if (options.customRowRender) {
          return options.customRowRender(row, dataIndex, rowIndex);
        }
        var isRowSelected = options.selectableRows !== 'none' ? _this2.isRowSelected(dataIndex) : false;
        var isRowSelectable = _this2.isRowSelectable(dataIndex);
        var bodyClasses = options.setRowProps ? options.setRowProps(row, dataIndex, rowIndex) : {};
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: rowIndex
        }, /*#__PURE__*/_react.default.createElement(_TableBodyRow.default, _extends({}, bodyClasses, {
          options: options,
          rowSelected: isRowSelected,
          isRowSelectable: isRowSelectable,
          onClick: _this2.handleRowClick.bind(null, row, {
            rowIndex: rowIndex,
            dataIndex: dataIndex
          }),
          className: (0, _classnames.default)((_ref = {}, _defineProperty2(_ref, classes.lastStackedCell, options.responsive === 'vertical' || options.responsive === 'stacked' || options.responsive === 'stackedFullWidth'), _defineProperty2(_ref, classes.lastSimpleCell, options.responsive === 'simple'), _defineProperty2(_ref, bodyClasses.className, bodyClasses.className), _ref)),
          "data-testid": "MUIDataTableBodyRow-".concat(dataIndex),
          id: "MUIDataTableBodyRow-".concat(dataIndex)
        }), options.selectCellPostion === 'left' && /*#__PURE__*/_react.default.createElement(_TableSelectCell.default, {
          onChange: _this2.handleRowSelect.bind(null, {
            index: _this2.getRowIndex(rowIndex),
            dataIndex: dataIndex
          }),
          onExpand: toggleExpandRow.bind(null, {
            index: _this2.getRowIndex(rowIndex),
            dataIndex: dataIndex
          }),
          fixedHeader: options.fixedHeader,
          fixedSelectColumn: options.fixedSelectColumn,
          checked: isRowSelected,
          expandableOn: options.expandableRows
          // When rows are expandable, but this particular row isn't expandable, set this to true.
          // This will add a new class to the toggle button, MUIDataTableSelectCell-expandDisabled.
          ,

          hideExpandButton: !_this2.isRowExpandable(dataIndex) && options.expandableRows,
          selectableOn: options.selectableRows,
          selectableRowsHideCheckboxes: options.selectableRowsHideCheckboxes,
          isRowExpanded: _this2.isRowExpanded(dataIndex),
          isRowSelectable: isRowSelectable,
          id: "MUIDataTableSelectCell-".concat(dataIndex)
        }), row.map(function (column, columnIndex) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, columns[columnIndex].display === 'true' && /*#__PURE__*/_react.default.createElement(_TableBodyCell.default, _extends({}, columns[columnIndex].setCellProps ? columns[columnIndex].setCellProps(column, dataIndex, columnIndex) : {}, {
            "data-testid": "MuiDataTableBodyCell-".concat(columnIndex, "-").concat(rowIndex),
            dataIndex: dataIndex,
            rowIndex: rowIndex,
            colIndex: columnIndex,
            columnHeader: columns[columnIndex].label,
            print: columns[columnIndex].print,
            firstIcon: columns[columnIndex].firstIcon,
            lastIcon: columns[columnIndex].lastIcon,
            options: columns[columnIndex].icon ? _objectSpread(_objectSpread({}, options), {}, {
              icon: true
            }) : options,
            key: columnIndex,
            className: columnIndex === 2 && options.origin === 'STUDIES IN THIS PROGRAM' && classes.root
          }), column));
        }), options.selectCellPostion === 'right' && /*#__PURE__*/_react.default.createElement(_TableSelectCell.default, {
          onChange: _this2.handleRowSelect.bind(null, {
            index: _this2.getRowIndex(rowIndex),
            dataIndex: dataIndex
          }),
          onExpand: toggleExpandRow.bind(null, {
            index: _this2.getRowIndex(rowIndex),
            dataIndex: dataIndex
          }),
          fixedHeader: options.fixedHeader,
          fixedSelectColumn: options.fixedSelectColumn,
          checked: isRowSelected,
          expandableOn: options.expandableRows
          // When rows are expandable, but this particular row isn't expandable, set this to true.
          // This will add a new class to the toggle button, MUIDataTableSelectCell-expandDisabled.
          ,

          hideExpandButton: !_this2.isRowExpandable(dataIndex) && options.expandableRows,
          selectableOn: options.selectableRows,
          selectableRowsHideCheckboxes: options.selectableRowsHideCheckboxes,
          isRowExpanded: _this2.isRowExpanded(dataIndex),
          isRowSelectable: isRowSelectable,
          id: "MUIDataTableSelectCell-".concat(dataIndex)
        })), _this2.isRowExpanded(dataIndex) && options.renderExpandableRow(row, {
          rowIndex: rowIndex,
          dataIndex: dataIndex
        }));
      }) : /*#__PURE__*/_react.default.createElement(_TableBodyRow.default, {
        options: options
      }, /*#__PURE__*/_react.default.createElement(_TableBodyCell.default, {
        colSpan: options.selectableRows !== 'none' || options.expandableRows ? visibleColCnt + 1 : visibleColCnt,
        options: options,
        colIndex: 0,
        rowIndex: 0
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "body1",
        className: classes.emptyTitle
      }, options.textLabels.body.noMatch))));
    }
  }]);
  return TableBody;
}(_react.default.Component);
_defineProperty(TableBody, "propTypes", {
  /** Data used to describe table */
  data: _propTypes.default.array.isRequired,
  /** Total number of data rows */
  count: _propTypes.default.number.isRequired,
  /** Columns used to describe table */
  columns: _propTypes.default.array.isRequired,
  /** Options used to describe table */
  options: _propTypes.default.object.isRequired,
  /** Data used to filter table against */
  filterList: _propTypes.default.array,
  /** Callback to execute when row is clicked */
  onRowClick: _propTypes.default.func,
  /** Table rows expanded */
  expandedRows: _propTypes.default.object,
  /** Table rows selected */
  selectedRows: _propTypes.default.object,
  /** Callback to trigger table row select */
  selectRowUpdate: _propTypes.default.func,
  /** The most recent row to have been selected/unselected */
  previousSelectedRow: _propTypes.default.object,
  /** Data used to search table against */
  searchText: _propTypes.default.string,
  /** Toggle row expandable */
  toggleExpandRow: _propTypes.default.func,
  /** Extend the style applied to components */
  classes: _propTypes.default.object
});
_defineProperty(TableBody, "defaultProps", {
  toggleExpandRow: function toggleExpandRow() {}
});
var _default = (0, _styles.withStyles)(defaultBodyStyles, {
  name: 'MUIDataTableBody'
})(TableBody);
exports.default = _default;